import * as React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import { Order, BatData } from './iMonCompte';
import {
  renderFilArianne,
  renderTitleH1,
} from './RenderCommon';
import {getUserId, sessionExpire} from './MonCompteAction';
import { formatDate, formatNumCommande } from './OrderAction';
import RenderBatBySurfaceEmplacement from './RenderBatBySurfaceEmplacement';
import Icons from './Icons';
import {getEnv, getFeatureEnabledPostprocessing, getHostApi, getRequestConfig} from "../../utils";
import RenderCountdown from "./RenderCountdown";
import moment from "moment";
import 'moment/locale/fr';
import Model3dView from './upload/components/Model3dView';

export default class RenderBat extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      selectedOrderId: this.props.match.params.id,
      commentaire: '',
      open: false,
      confirmerFichiers: true,
      showNotes: false,
      setValidationBatClicked: false,
      isBatAuto: false,
      activateBatAutoBroderieAffichageClient: false,
      enabledPostProcessing: false
    };
  }

  componentDidMount() {
    this._getOrders();
    getFeatureEnabledPostprocessing()
      .then(response => this.setState({ enabledPostProcessing: response.data?.feature ?? false}));
  }

  _getDatas() {
    axios.get(getHostApi() + '/customers/' + getUserId() + '/orders/' + this.state.selectedOrderId + '/bat', getRequestConfig())
      .then((response) => {
      if (response.data.datas) {
        this.setState({ datas: response.data.datas });
      }
    }).catch((error) => {
      if (error.response.status === 401) { sessionExpire(); }
    });
  }

  _setValidationBAT = () => {
    if (this.state.setValidationBatClicked) {
      return;
    }
    this.setState({ open: false, setValidationBatClicked: true });
    axios.post(getHostApi() + '/customers/' + getUserId() + '/orders/' + this.state.selectedOrderId + '/bat',
        { value: this.state.value, commentaire: this.state.commentaire, confirmerFichiers: this.state.confirmerFichiers,  dates: { dateDepart: this.state.order.DateDepart, dateLivraison: this.state.order.date_livraison_prevue }}, getRequestConfig())
        .then((response) => {
          this.setState({ retour: response.data.retour }, () => { this._getOrder(); });
        }).catch((error) => {
      if (error.response.status === 401) { sessionExpire(); }
    }).finally(() => {
      this.setState({ setValidationBatClicked: false });
    });
  }

  _onUpdateInput = () => {
    this.setState({ confirmerFichiers: !this.state.confirmerFichiers });
  }

  _getOrders() {
    axios.get(getHostApi() + '/customers/' + getUserId() + '/orders/', {
      ...getRequestConfig(),
      params: {
        diff_validation_bat: 0,
        diff_StatutCommande: 9,
      },
    }).then((response) => {
      if (response.data.orders) {
        this.setState({
          orders: response.data.orders,
        }, () => { this._defineSelectedOrder(); });
      }
    }).catch((error) => {
      if (error.response.status === 401) { sessionExpire(); }
    });
  }

  _getOrder() {
    axios.get(getHostApi() + '/customers/' + getUserId() + '/orders/' + this.state.selectedOrderId,
      getRequestConfig()).then((response) => {
      if (response.data.order) {
        this.setState({ order: response.data.order }, () => { this._getDatas(); this._fetchActivationBatAuto(); });
      }
    }).catch((error) => {
      if (error.response.status === 401) { sessionExpire(); }
    });
  }

  _onOrderUpdated = () => {
    this._getOrder();
  }

  _onChangeOrderSelected = (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ selectedOrderId: event.target.value }, () => {
      this._onOrderUpdated();
      window.history.pushState('', '', '/www/MonCompte/moncompte.php/bat/' + this.state.selectedOrderId);
    });
  }

  _defineSelectedOrder = () => {
    let orderId = this.state.selectedOrderId;

    if (!orderId) {
    if (this.state.orders.length > 0) {
      orderId = this.state.orders[0].idCommande;
    } else {
      orderId = '';
    }
    }

    this.setState({ selectedOrderId: orderId }, () => { this._getOrder(); });

    return orderId;
  }

  _encode_utf8(texte: string) {
    return unescape(encodeURIComponent(texte));
  }

  _fetchActivationBatAuto = () => {
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.selectedOrderId}/bat-auto`,
      getRequestConfig()).then((response) => {
      if (response.data) {
        this.setState({ isBatAuto : response.data.isBatAuto }, () => {
          if(response.data.isBatAuto) {
            this._fetchBatAutoBroderieAffichageClient();
          }
        });
      }
    }).catch((error) => {
      if (error.response.status === 401) { sessionExpire(); }
    });
  }

  onOpenModal = (texte: string) => {
    this.setState({ open: true, texteModal: texte });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  _confirmRefus = (sansCommentaire: boolean = false) => {
    if (sansCommentaire) {
      document.getElementById('textareaMotifRefus')?.classList.add('borderRedRefusBAT');
    } else {
      if (!this.state.datas.role || this.state.datas.role.id == '' ||
        this.state.datas.role.id == '22' || this.state.datas.role.id == '34' || this.state.datas.role.id == '45') {
        this.setState({ value: 0 });
        this.onOpenModal('Refuser la validation du BAT peut repousser la date de livraison de votre commande. ' +
          'Etes-vous certain de vouloir refuser ce BAT ?');
      } else {
        this.setState({ value: 0 });
        this.onOpenModal('Refuser la validation du BAT peut repousser la date de livraison de votre commande. ' +
          'Etes-vous certain de vouloir refuser ce BAT ?');
      }
    }
  }

  _confirmAccept = () => {
    const env = getEnv();
    if (env === 'preprod' || (!this.state.datas.role || this.state.datas.role.id == '' || this.state.datas.role.id == '22' || this.state.datas.role.id == '34' || this.state.datas.role.id == '45')) {
      this.setState({value: 2});
      if (this.state.commentaire.length > 0) {
        this.onOpenModal('Etes-vous certain de vouloir accepter ce BAT ? Votre commentaire ne sera pas pris en compte : "' + this.state.commentaire + '"');
      } else {
        this.onOpenModal('Etes-vous certain de vouloir accepter ce BAT ?');
      }
    }
  }

  _onChangeCommentaire = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ commentaire: event.target.value });
  }

  _showNotes = ()  => {
    this.setState({ showNotes : !this.state.showNotes });
  }

  _onUpdateDateLivraisonPrevue = (dateLivraison: string) => {
    this.setState({
      order:{
        ...this.state.order,
        date_livraison_prevue: dateLivraison,
      },
    });
  }

  _fetchBatAutoBroderieAffichageClient = () => {
    axios.get(`${getHostApi()}/shops/features/bat_auto_broderie_affichage_client`,
      getRequestConfig()).then((response) => {
      if (response.data.feature) { this.setState({ activateBatAutoBroderieAffichageClient: response.data.feature }); }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }

  render() {
    const renderModal = () => {
      return (
        <Modal open={this.state.open} onClose={this.onCloseModal} center
               classNames={{overlay: 'bootstrap-container', modal: ' customModal',
                 closeButton: 'closeButton'}}>
          <div className="modalOrder p-2 pa0Mobile">
            {this.state.value == 0 ? (
              <>
              <p className={'text-center '}>Refuser un BAT peut décaler la date de livraison de votre commande.</p>
              <p className={'text-center bold'}>Etes-vous certain de vouloir refuser ce BAT ?</p>
              <div className={'my-0 my-md-5'}>
                <div className={'border  border-left-0 border-right-0 py-4 text-center my-4'}>
                  <span className={'black bold'}>Motif du refus : </span>

                  {renderEmptyComment()}
                </div>
              </div>
              </>
            ) : (
              <p className={'text-center bold py-4 '}>{this.state.texteModal}</p>
            )}
            <div className={'d-flex justify-content-between align-items-start'}>
              <div className={'d-flex w-50 mr-2 mr-md-5 flex-md-column flex-column-reverse'}>
                {this.state.value == 0 &&
                <div className="form-check  mb-4 mt-4  mt-md-0 small">&nbsp; </div>
                }
              <button title="Annuler" onClick={this.onCloseModal} className="borderBlack w-100 bold bg-white1 cursor-pointer btnCancelModal   py-4 px-3">
                Non
              </button>
              </div>
              <div className={'d-flex w-75 ml-2 ml-md-5 flex-md-column flex-column-reverse'}>
                {this.state.value == 0 &&
                <div className="form-check mb-4 mt-4 mt-md-0 d-flex align-items-start align-items-md-center justify-content-center pl-0">
                  <input type="checkbox"  onChange={this._onUpdateInput}  checked={!this.state.confirmerFichiers} className=" mt-1 mt-md-0 pl-0" id="modifierMesFichiers" />
                  <label className="form-check-label small ml05" htmlFor="modifierMesFichiers"> Je souhaite pouvoir modifier mes fichiers envoyés</label>
                </div>
                }
                { ((this.state.value == 0 && this.state.commentaire.length >= 10) || this.state.value != 0)  ? (
                  <button onClick={this._setValidationBAT}
                          className="borderBlack  bold bg-white1 cursor-pointer btnValidateModal  w-100 py-4 px-3">
                    Oui
                    {this.state.value == 0 &&
                    <>, je refuse</>
                    }
                  </button>
                  ) : (
                    <button  onClick={e => this._confirmRefus(true)}
                            className="borderBlack  bold bg-white1 cursor-pointer btnValidateModal  w-100 py-4 px-3">
                      Oui
                      {this.state.value == 0 &&
                      <>, je refuse</>
                      }
                    </button>
                  )}
              </div>
            </div>
          </div>
        </Modal>
      );
    };

    const renderOptionsSelectOrders = () => {
      const defineText = (order: Order) => {
        if (order.validation_bat == '1') {
          return 'BAT à valider : ';
        }
      };

      const options = [];

      for (const order of this.state.orders) {
        if (order.cf != '1' && order.validation_bat != '0' && order.StatutCommande != '9' && moment(order.DateDeCommande) >= moment(order.last2Years)) {
          options.push(
            <option value={order.idCommande} key={order.idCommande}>
              {defineText(order)}
              Commande {formatNumCommande(order.numCommande)} du {formatDate(order.DateDeCommande.split(' ')[0])}
            </option>,
          );
        }
      }
      return options;
    };

    const renderSelectOrders = () => {
      if (this.state.orders && this.state.selectedOrderId) {
        return (
          <div className="text-right">
            <select className="selectOrdersBat" onChange={e => this._onChangeOrderSelected(e)} defaultValue={this.state.selectedOrderId}>
              {renderOptionsSelectOrders()}
            </select>
          </div>
        );
      }
    };

    const renderNotes = () => {
      return (
        <div className="mt-5 d-flex flex-column justify-content-center align-items-center">
          <button onClick={ e => this._showNotes()} className={'btn grey border d-flex align-items-center font12 mt-5'}>
            En savoir plus sur mon BAT
            {this.state.showNotes &&
            <Icons className={'pt-2 pl-2'} icon="close" size={24}/>
            }
          </button>
          {this.state.showNotes &&
          <div className={'border encartNotesBat align-self-start mt-4 p-4'}>
            <p className={'grey'}>
              <span className={'bold'}>Plus d'informations sur mon BAT :</span><br/>
              <ul className={'pl-4'}>
                <li>Les visuels fournis sont redimensionnés et placés automatiquement selon les caractéristiques de
                  votre commande.
                </li>
                <li>L'emplacement et la dimension de vos visuels ne peuvent pas être modifiés.</li>
                <li>Les pictogrammes représentant les articles sont non contractuels.</li>
                <li>Les couleurs du BAT sont des couleurs écran données à titre indicatif, elles ne peuvent refléter les
                  couleurs sur le textile marqué.
                </li>
              </ul>
            </p>
            <p className="grey">
              <span className={'bold'}>Refuser mon BAT :</span><br/>
              Dans le cas d'un refus du BAT, vous avez la possibilité d'envoyer de nouveaux fichiers ainsi que d'ajouter
              un commentaire destiné à l'opérateur traitant votre commande. Un nouveau BAT vous sera ensuite notifié.
              Refuser la validation du BAT peut repousser la date de livraison de votre commande.
            </p>
          </div>
          }
        </div>
      );
    };

    const renderEmptyComment = () => {
      const caracteresRestant = 140 - this.state.commentaire.length;
      let classAlert = 'border-dark';
      let msg = '';

      if (this.state.commentaire.length > 0 && this.state.commentaire.length < 10) {
        classAlert = 'borderRedRefusBAT'; msg = 'Veuillez saisir au moins 10 caractères.';
      }
      return (
          <div className="text-center d-flex align-items-start mt1">
            <div className="flex-grow-1">
                <textarea id="textareaMotifRefus" className={'w-100 p-2 ' + classAlert} rows={3} maxLength={140}
                          placeholder={'Attention : Si vous souhaitez refuser le BAT, merci de nous justifier ce choix afin de traiter au mieux votre commande.'}
                          onChange={e => this._onChangeCommentaire(e)}>
                </textarea>
              <div>
                <p className={'float-left red pt-2'}>{msg}</p>
                <p className={'text-right grey pt-2 mb-0'}>Caractères restants : {caracteresRestant}/140</p>
              </div>
            </div>
          </div>
      );
    };

    const renderButtons = () => {
      let classe = 'white cursor-not-allowed';
      if (!this.state.datas.role || this.state.datas.role.id == '' || this.state.datas.role.id == '22' || this.state.datas.role.id == '34' || this.state.datas.role.id == '45' || this.state.datas.role.id == '25') {
        classe = 'btn-accepter';
      }

      const renderDateLivraisonEstimee = () => {
        const livraisonEstimee = moment(this.state.order.date_livraison_prevue !== '0000-00-00' ? this.state.order.date_livraison_prevue : this.state.order.DateSouhaite).locale('fr').format('dddd DD MMMM');
        return (
          <p className=" text-center mb-md-1 mt-3 pb-3">
            Temps restant pour une livraison estimée le&nbsp;<span className={'bold'}>{livraisonEstimee}</span> :</p>
        );
      };

      return (
        <>
          <div className="d-flex align-items-center justify-content-center mt-3 flex-column ">
            <div className={'mr-4  d-flex  flex-column align-items-center justify-content-center mb-5'}>
              {this.state.order.infosCompteur && this.state.order.sav != '1' &&
              <>
              {renderDateLivraisonEstimee()}
              <RenderCountdown type={'BAT'} idCommande={this.state.order.idCommande} dateLivraisonPrevue={this.state.order.date_livraison_prevue !== '0000-00-00' ? this.state.order.date_livraison_prevue : this.state.order.DateSouhaite} infosCompteur={this.state.order.infosCompteur} onChangeDateLivraison={this._onUpdateDateLivraisonPrevue}/>
              </>
              }
            </div>
            <div className={'mx-auto mx-md-0'}>
            {this.state.commentaire.length > 9 || 1 === 1 ? <button className="mr-3 button buttonPrimary  btnBat  border border-black bg-transparent black  py-1 px-5 px-md-5 "
               onClick={e => this._confirmRefus()}>
              Refuser le BAT
            </button> : <button onClick={e => this._confirmRefus(true)} className="mr-3 button buttonPrimary cursor-notAllowed  btnBat  bg-lightgrey grey border py-1 px-5 px-md-5" title="Un motif est obligatoire pour refuser un BAT">Refuser le BAT</button>}

            <button className={'button buttonPrimary  btnBat    py-1 px-5 px-md-5    ml-3 ml-md-4 ' + classe + ' white border-0 bg-blue'}
                     onClick={e => this._confirmAccept()}>
              Accepter le BAT
            </button>
            </div>
            {renderModal()}
          </div>
        </>
      );
    };

    const renderInfosProduit = (data: BatData) => {
      const defineCategorie = () => {
        if (data.quantite === '1') {
          return data.singulier;
        }
        return data.categorie;
      };
      return (
        <div className="text-center pr-2 col-md-3 d-flex flex-column infosProduitBat">
          <div className="hide-for-small">
            <div className="d-block w-100 text-center">
              <img src={data.lienImage} alt={data.Titre} width={70} />
            </div>
          </div>
          <div className="info-produit-bat">
            {data.categorie != null &&
            <div className="bold black font16 text-uppercase">
              {data.quantite} {defineCategorie()}
            </div>
            }
            <div className="text-uppercase bold black">
              {data.Titre}
            </div>
            <div>
              <span className="black my-1 pastilleReferenceVisible">Réf : {data.reference_visible}</span>
            </div>
            <div>
              Couleur : <span className="black">{data.couleur}</span>
            </div>
            <div>
              Tailles : <span className="black">{data.tailles}</span>
            </div>
          </div>
          <div>
            <Icons icon="arrow_downard" size={30}  />
          </div>
        </div>
      );
    };

    const renderPositions = (data: BatData) => {
      const html = [];
      let classLg = 'col-lg-3';
      let classMd = 'col-md-3';
      let classes = '';
      if(data && data.surfacesId) {
        if (data.surfacesId.length === 2) {
          classLg = 'col-lg-6';
          classMd = 'col-md-6';
          classes = 'flexIsRow';
        } else if (data.surfacesId.length === 3) {
          classLg = 'col-lg-4';
          classMd = 'col-md-4';
        } else if (data.surfacesId.length === 1) {
          classLg = 'col-lg-6 offset-lg-3 ';
          classMd = 'col-md-6 offset-md-3';
          classes = 'flexIsRow';
        }
        for (let i = 0; i < data.surfacesId.length; i++) {
          html.push(
            <div className={'text-center p-1 pr-0 positionBat ' + classLg + ' ' + classMd + ' ' + classes}
                 key={data.Titre + '-' + data.creation_id + '-' + i}>
              <RenderBatBySurfaceEmplacement order={this.state.order} data={data} index={i}
                                             isBatAuto={this.state.isBatAuto}
                                             activateBatAutoBroderieAffichageClient={this.state.activateBatAutoBroderieAffichageClient}/>
            </div>,
          );
        }
      } else {
        html.push(
          <div className={'text-center p-1 pr-0 flex-grow-1 italic'}>
            Aucune personnalisation
            </div>
        )
      }

      return <div className={`${data.isModel3d ? 'col-md-6' : 'col-md-9'} row pr-0 align-items-stretch`}>{html}</div>;
    };

    const renderDetails = () => {
      const html = [];
      for (const data of this.state.datas.batDatas) {
        const model3dViewData = {
          creation_id: data.creation_id,
          article: {
            produit: {
              idProduits: data.idProduits,
            },
            couleur: {
              code1: data.code1,
              idCouleursArticles: data.couleur_id
            }
          },
          marquages: data?.emplacement_angle?.map((angle: number) => ({ angle_3d: angle })) ?? []
        };
        html.push(
          <div className="row py-2 border-bottom-dotted d-flex align-items-center" key={data.creation_id}>
            {renderInfosProduit(data)}
            {data.isModel3d &&
              <div className='col-md-3 colonneModel3d'>
                <Model3dView
                  mesBatView
                  panier={model3dViewData}
                  idCommande={parseInt(this.state.order.idCommande,10)}
                  numCommande={this.state.order.numCommande}
                  enabledPostProcessing={this.state.enabledPostProcessing}
                />
              </div>
            }
            {renderPositions(data)}
          </div>,
        );
      }

      return (
        <div className="my-3">{html}</div>
      );
    };

    const renderConditionsBat = () => {
      if (this.state.order.validation_bat == '1') {
        return (
          <div>
            {renderCommentaireBat()}
            {renderButtons()}
            {renderNotes()}
          </div>
        );
      } else if (this.state.order.validation_bat == '2') {
        return (
          <div>
            {renderCommentaireBat()}
          </div>

        );
      }
    };

    const renderBat = () => {
      if (!this.state.retour && (this.state.order.validation_bat == '1' || this.state.order.validation_bat == '2')) {
        return (
          <div>
            {renderDetails()}
            {renderConditionsBat()}
          </div>
        );
      }
    };
    const renderCommentaireBat = () => {
      if ((this.state.order.validation_bat == '1' || this.state.order.validation_bat == '2') && this.state.order.commentaire_bat !== '' &&  this.state.order.commentaire_bat.length > 3) {
        return (
            <div className="commentaireBAT font16 alert alert-warning text-center">
              <Icons icon="warning" size={18} className={"mr-1"}  />
                <span className="bold">Pr&eacute;cision du service de fabrication :</span>
              <p> {this.state.order.commentaire_bat }</p>
            </div>
        );
      }
    };

    const renderNoBat = () => {
      if (!this.state.retour && this.state.order.validation_bat != '1' && this.state.order.validation_bat != '2') {
        return (
          <div className="text-center mt-4 font14 black">
            <p>Il n'y a aucun BAT qui requiert votre validation actuellement.</p>
          </div>
        );
      }
    };

    const renderTexteRetour = () => {
      if (this.state.value === 0) {
        return (
          <div className=" my-4 blightblue w-75 info-txt-refus-bat text-center border border-black mx-auto p-4 font14">
            <p className="bold ma0">Vous avez refusé de valider le Bon à Tirer de votre commande.</p>

            {this.state.commentaire && this.state.commentaire.length > 1 &&
            <div className="my-5"><span className={'bold'}>Motif du refus :</span>
              <p>{this.state.commentaire}</p>
            </div>
            }
            {!this.state.confirmerFichiers ? (
            <p className="bold my-5">
              Vous avez souhaité pouvoir envoyer de nouveaux fichiers :
              <Link className={'py-2 px-3  fileBigButton d-block  button buttonPrimary  btnBat  bg-blue w-75 mt-2  py-1 px-3 px-md-3 border-0  white'} to={`/files/${this.state.order.idCommande}`}>
                <Icons icon="file_upload" size={20} color={'white'}/> <span className="pl-1">Envoi des fichiers</span>
              </Link>
            </p>
            ) : (
            <p>Un nouveau BAT sera à valider, vous en serez notifié par un email</p>
            )}
          </div>
        );
      }

      return (
        <div className="p-2 my-4 bg-green font14">
          <p>BAT validé avec succès !</p>
          <p>
            Votre commande est en cours de fabrication. Un email de suivi vous sera envoyé lors de l'expédition de la
            commande.
          </p>
        </div>
      );
    };

    const renderRetour = () => {
      if (this.state.retour) {
        return (
          <div>
            {renderTexteRetour()}
            {renderNotes()}
          </div>
        );
      }
    };

    const renderPage = () => {
      if (this.state.datas) {
        return (
          <div>
            {renderSelectOrders()}
            {renderBat()}
            {renderNoBat()}
            {renderRetour()}
          </div>
        );
      } else {
        return (
            <div className="text-center mt-4 font14 black">
              <p>Il n'y a aucun BAT qui requiert votre validation actuellement.</p>
            </div>
        );
      }
    };

    return (
      <div>
        {renderTitleH1('bat', 'Mes BAT')}
        {renderFilArianne('', 'Mes BAT')}
        {renderPage()}
      </div>
    );
  }
}
